require('daterangepicker');

/**
 * Initialize the date time picker
 */
export function initializeDateTimePicker() {
    //Down
    let datetime = $('[data-toggle="datepicker-datetime"]');

    datetime.daterangepicker({
        autoUpdateInput: false,
        timePicker: true,
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        locale: {
            format: 'YYYY-MM-DD HH:mm',
            cancelLabel: 'Clear'
        },
        ignoreReadonly: true
    }, function (start, end, label) {
    });

    datetime.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'));
    });

    datetime.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    //Up
    let datetimeUp = $('[data-toggle="datepicker-datetime-up"]');

    datetimeUp.daterangepicker({
        autoUpdateInput: false,
        timePicker: true,
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        drops: 'up',
        locale: {
            format: 'YYYY-MM-DD HH:mm',
            cancelLabel: 'Clear'
        }
    }, function (start, end, label) {
    });

    datetimeUp.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm'));
    });

    datetimeUp.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    //Down
    let date = $('[data-toggle="datepicker-date"]');
    date.daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
        },
        ignoreReadonly: true
    }, function (start, end, label) {
    });

    date.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
    });

    date.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    //Up
    let dateUp = $('[data-toggle="datepicker-date-up"]');
    dateUp.daterangepicker({
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        drops: 'up',
        locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
        }
    }, function (start, end, label) {
    });

    dateUp.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'));
    });

    dateUp.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    //Down
    let dateRange = $('[data-toggle="datepicker-range"]');
    dateRange.daterangepicker({
        autoUpdateInput: false,
        showDropdowns: true,
        locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
        },
    });

    dateRange.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'))
            .trigger('change');
    });

    dateRange.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('').trigger('change');
    });

    //Down
    let dateRangeTime = $('[data-toggle="datepicker-range-time"]');
    dateRangeTime.daterangepicker({
        autoUpdateInput: false,
        timePicker: true,
        showDropdowns: true,
        locale: {
            format: 'YYYY-MM-DD HH:mm',
            cancelLabel: 'Clear'
        },
    });

    dateRangeTime.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm') + ' - ' + picker.endDate.format('YYYY-MM-DD HH:mm'))
            .trigger('change');
    });

    dateRangeTime.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('').trigger('change');
    });

    //Up
    let dateRangeUp = $('[data-toggle="datepicker-range-up"]');
    dateRangeUp.daterangepicker({
        autoUpdateInput: false,
        drops: 'up',
        showDropdowns: true,
        locale: {
            format: 'YYYY-MM-DD',
            cancelLabel: 'Clear'
        }
    });

    dateRangeUp.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD'))
            .trigger('change');
    });

    dateRangeUp.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('').trigger('change');
    });

    let dateRangeTimeUp = $('[data-toggle="datepicker-range-time-up"]');
    dateRangeTimeUp.daterangepicker({
        autoUpdateInput: false,
        timePicker: true,
        drops: 'up',
        showDropdowns: true,
        locale: {
            format: 'YYYY-MM-DD HH:mm',
            cancelLabel: 'Clear'
        }
    });

    dateRangeTimeUp.on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD HH:mm') + ' - ' + picker.endDate.format('YYYY-MM-DD HH:mm'))
            .trigger('change');
    });

    dateRangeTimeUp.on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('').trigger('change');
    });
}
